import { i18n } from '@/plugins/i18n';

export const openBankingTransactionStatus = {
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2,
    UNKNOWN_YET: 3,
    TRANSFER_UNKNOWN: 4,
    REJECTING: 5,
    REJECT_FAILED: 6,
    REVERSAL: 7,
};

export const openBankingTransactionStatusStr = {
    PENDING: i18n.t('open_banking.transactions.transaction_statuses.pending'),
    APPROVED: i18n.t('open_banking.transactions.transaction_statuses.approved'),
    REJECTED: i18n.t('open_banking.transactions.transaction_statuses.rejected'),
    UNKNOWN_YET: i18n.t('open_banking.transactions.transaction_statuses.unknown_yet'),
    TRANSFER_UNKNOWN: i18n.t('open_banking.transactions.transaction_statuses.transfer_unknown'),
    REJECTING: i18n.t('open_banking.transactions.transaction_statuses.rejecting'),
    REJECT_FAILED: i18n.t('open_banking.transactions.transaction_statuses.reject_failed'),
    REVERSAL: i18n.t('open_banking.transactions.transaction_statuses.reversal'),

    get(status) {
        let status_str = null;

        Object.keys(openBankingTransactionStatus).forEach((item) => {
            if (openBankingTransactionStatus[item] === status) {
                status_str = openBankingTransactionStatusStr[item];
            }
        });

        return status_str;
    }
};

const openBankingTransactionStatusBadgeMap = {
    [openBankingTransactionStatus.PENDING]: 'warning',
    [openBankingTransactionStatus.APPROVED]: 'success',
    [openBankingTransactionStatus.REJECTED]: 'danger',
    [openBankingTransactionStatus.UNKNOWN_YET]: 'dark',
    [openBankingTransactionStatus.TRANSFER_UNKNOWN]: 'secondary',
    [openBankingTransactionStatus.REJECTING]: 'info',
    [openBankingTransactionStatus.REJECT_FAILED]: 'primary',
    [openBankingTransactionStatus.REVERSAL]: 'orange',
};

export const openBankingTransactionStatusBadge = status => openBankingTransactionStatusBadgeMap[status];
